module.exports = __webpack_public_path__ + "static/media/super_pack_fr_chien_automne.65148e9e.png";